function handleShippingAddress() {
  var $shippingCheckbox = $('#shipping_address_feature');
  var $shippingAddressFields = $('#shipping-address-fields');
  var $inputs = $shippingAddressFields.find('input, select');

  function useBillingAddressIsChecked() {
    return $shippingCheckbox.is(':checked');
  }

  function removeRequiredAttr() {
    $inputs.prop('required', false);
  }

  function applyRequiredAttr() {
    $inputs.filter(function () {
      var $input_label = $('label[for="' + $(this).attr('id') + '"]');
      return $(this).is(':visible') && $input_label.hasClass('required');
    }).attr('required', true);
  }

  function listenForShippingAddressCheckboxClick() {
    $('#shipping_address_feature').on('click', function () {
      if (useBillingAddressIsChecked()) {
        $shippingAddressFields.addClass('hidden');
        removeRequiredAttr();
      } else {
        $shippingAddressFields.removeClass('hidden');
        applyRequiredAttr();
      }
    });
  }

  listenForShippingAddressCheckboxClick();
}

var ShippingAddress = {
  handleShippingAddress: handleShippingAddress
};
export default ShippingAddress;